import React from "react";
import CampaignCard from "../../components/CampaignComponents/CampaignCard";
import { getCampaignStatus } from "../../utils";

const Campaigns = ({ data = [], timezone }) => {
  return (
    <>
      {data.length ? (
        data.map(({ node }, i) => (
          <CampaignCard
            campaign={node}
            key={`campaign-card-${i}`}
            timezone={timezone}
            campaignStatus={getCampaignStatus(
              node.acfCampaignDate,
              timezone.tz
            )}
          />
        ))
      ) : (
        <div
          className="my-5 mx-auto px-5 py-3 w-100"
          style={{
            backgroundColor: "#f0f1f3",
          }}
        >
          NOT FOUND
        </div>
      )}
    </>
  );
};

export default Campaigns;
